import React, { Component, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  getDistribuitorPriceHistory,
  getProducts,
  getProviders,
} from "helpers/backend_helper"
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  InputGroup,
  Label,
  Row,
  Table,
  Spinner,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap"
import ComparePricesGraph from "./compare_graph"
import { useEffect } from "react"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import Flatpickr from "react-flatpickr"
import { getDistribuitorPriceTable } from "../../../helpers/backend_helper"
import * as moment from "moment"
import Select from "react-select"
import Breadcrumb from "components/Common/Breadcrumb"
import { useFormik } from "formik"
import classnames from "classnames"
import NibbleBaseInput from "components/Nibble/Common/Inputs/NibbleBaseInput"

const nf = new Intl.NumberFormat('es-MX', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const initialPeriod =
  moment().startOf("month").format("YYYY-MM-DD") +
  "/" +
  moment().endOf("month").format("YYYY-MM-DD")

const AnalizePrices = props => {
  const [activeTab, setActiveTab] = useState("proveedor")
  const [level, setLevel] = useState(null)
  const [products, setProducts] = useState([])
  const [providers, setProviders] = useState([])
  const [selectedPeriod, setSelectedPeriod] = useState([moment().startOf("week").toDate(), moment().endOf("week").toDate()])
  const [selectedProduct, setSelectedProduct] = useState([
    { "label": "HEMBRA", "value": 9 },
    { "label": "MACHO", "value": 10 },
    { "label": "MIXTO", "value": 11 }
  ])
  const [selectedProviders, setSelectedProviders] = useState([])
  const [selectedRow, setSelectedRow] = useState(null)
  const [tableData, setTableData] = useState([])
  const [series, setSeries] = useState([])
  const [options, setOptions] = useState([])

  const [tableData2, setTableData2] = useState([])
  const [series2, setSeries2] = useState([])
  const [options2, setOptions2] = useState([])

  const [fechas, setFechas] = useState([])
  const [loading, setLoading] = useState(false)

  const validation = useFormik({
    initialValues: {
      promedio_producto: false,
      promedio_destino: false,
    },
    onSubmit: values => { }
  })

  useEffect(() => {
    async function getProductsCatalog() {
      const response = await getProducts()
      let products = response.map(e => {
        return {
          label: `${e.name}`,
          value: e.id,
        }
      })
      setProducts([...products])
    }

    async function getProvidersCatalog() {
      const response = await getProviders()
      let providers = response.map(e => {
        return {
          label: `${e.skey ?? ""} ${e.company_name}`,
          value: e.id,
        }
      })
      setProviders(providers)
    }

    getProductsCatalog()
    getProvidersCatalog()
  }, [])


  const setLevel1 = (dataPrices, fechas) => {
    let TABLE = []
    dataPrices.data = dataPrices.data_1;

    const endDate = moment(selectedPeriod[1])
    let SERIES = []

    const keys = Object.keys(dataPrices.data)
    for (var i = 0; i < keys.length; i++) {
      const keyProvider = keys[i]

      let total = 0
      let totalWeight = 0
      let count = 0

      let PRICES_DAY = []
      fechas.forEach(date => {
        let exist = dataPrices.data[keyProvider].filter(e => { return e.date == moment(date, 'DD-MM').format('YYYY-MM-DD') })
        PRICES_DAY.push(exist.length > 0 ? exist[0].price : 0)
      })

      dataPrices.data[keyProvider].forEach(e => {
        total += Number(e.price)
        totalWeight += Number(e.weight)
        count++;
      })

      let existProvider = dataPrices.providers.filter(e => { return e.id == keyProvider })

      TABLE.push({
        provider: (existProvider[0]?.skey ?? '') + ' | ' + (existProvider[0]?.company_name ?? ''),
        price_shipped: total / count,
        weight: totalWeight / count,
        prices_days: PRICES_DAY
      })
    }
    setTableData(TABLE)

    for (var i = 0; i < keys.length; i++) {
      let A = []
      const key = keys[i]
      const keyProvider = keys[i]
      const startDate3 = moment(selectedPeriod[0])
      for (; startDate3.isSameOrBefore(endDate); startDate3.add(1, 'day')) {
        let value = 0;
        let exist = dataPrices.data[key].filter(e => { return e.date == startDate3.format('YYYY-MM-DD') })
        A.push(exist.length > 0 ? exist[0].price : value)
      }

      let existProvider = dataPrices.providers.filter(e => { return e.id == keyProvider })

      SERIES.push({ name: existProvider[0].skey, data: A })
    }

    console.log(SERIES, fechas)
    setSeries(SERIES)
  }

  const setLevel2 = (dataPrices, fechas) => {
    let TABLE = []
    dataPrices.data = dataPrices.data_2;

    const endDate = moment(selectedPeriod[1])
    let SERIES = []

    const keys = Object.keys(dataPrices.data)
    for (var i = 0; i < keys.length; i++) {
      const [keyProvider, keyProduct] = keys[i].split('_')

      let total = 0
      let totalWeight = 0
      let count = 0

      let PRICES_DAY = []
      fechas.forEach(date => {
        let exist = dataPrices.data[keyProvider + '_' + keyProduct].filter(e => { return e.date == moment(date, 'DD-MM').format('YYYY-MM-DD') })
        PRICES_DAY.push(exist.length > 0 ? exist[0].price : 0)
      })

      dataPrices.data[keyProvider + '_' + keyProduct].forEach(e => {
        total += Number(e.price)
        totalWeight += Number(e.weight)
        count++;
      })

      let existProvider = dataPrices.providers.filter(e => { return e.id == keyProvider })
      let existProduct = products.filter(e => { return Number(e.value) == Number(keyProduct) })

      TABLE.push({
        provider: (existProvider[0]?.skey ?? '') + ' | ' + (existProvider[0]?.company_name ?? ''),
        product: (existProduct[0]?.label ?? ''),
        price_shipped: total / count,
        weight: totalWeight / count,
        prices_days: PRICES_DAY
      })
    }
    setTableData2(TABLE)

    for (var i = 0; i < keys.length; i++) {
      let A = []
      const key = keys[i]
      const [keyProvider, keyProduct] = keys[i].split('_')
      const startDate3 = moment(selectedPeriod[0])
      for (; startDate3.isSameOrBefore(endDate); startDate3.add(1, 'day')) {
        let value = 0;
        let exist = dataPrices.data[key].filter(e => { return e.date == startDate3.format('YYYY-MM-DD') })
        A.push(exist.length > 0 ? exist[0].price : value)
      }

      let existProvider = dataPrices.providers.filter(e => { return e.id == keyProvider })
      let existProduct = products.filter(e => { return e.value == keyProduct })
      SERIES.push({ name: existProvider[0].skey + ' ' + existProduct[0].label, data: A })
    }

    console.log(SERIES, fechas)
    setSeries2(SERIES)
    setOptions2(fechas)
  }

  const setLevel3 = (dataPrices) => {
    setLevel(3)
    let TABLE = []
    const keys = Object.keys(dataPrices.data_3)
    for (var i = 0; i < keys.length; i++) {
      const key = keys[i]
      const [keyProvider, region, keyProduct] = keys[i].split('_')

      let total = 0
      let totalWeight = 0
      let count = 0
      dataPrices.data[key].forEach(e => {
        total += Number(e.price)
        totalWeight += Number(e.weight)
        count++;
      })

      let existProvider = dataPrices.providers.filter(e => { return e.id == keyProvider })
      let existProduct = products.filter(e => { return Number(e.value) == Number(keyProduct) })

      TABLE.push({
        provider: existProvider[0]?.id + ' | ' + (existProvider[0]?.skey ?? ''),
        product: existProduct[0]?.value + ' | ' + (existProduct[0]?.label ?? ''),
        region: region,
        price_shipped: total / count,
        weight: totalWeight / count
      })
    }

    const keys2 = Object.keys(dataPrices.others)
    for (var i = 0; i < keys2.length; i++) {
      const key = keys2[i]
      const [keyProvider, region, keyProduct] = keys2[i].split('_')

      let total = 0
      let totalWeight = 0
      let count = 0
      dataPrices.others[key].forEach(e => {
        total += Number(e.price)
        totalWeight += Number(e.weight)
        count++;
      })

      TABLE.push({
        provider: dataPrices.others[key][0]?.enterprise ?? '',
        product: dataPrices.others[key][0]?.product ?? '',
        region: dataPrices.others[key][0]?.destino ?? '',
        price_shipped: total / count,
        weight: totalWeight / count
      })
    }

    setTableData(TABLE)

    const startDate = moment(selectedPeriod[0])
    const startDate2 = moment(selectedPeriod[0])
    const endDate = moment(selectedPeriod[1])
    let SERIES = []
    let OPTIONS = []
    for (; startDate2.isSameOrBefore(endDate); startDate2.add(1, 'day')) {
      OPTIONS.push(startDate2.format('DD-MM'))
    }

    for (var i = 0; i < keys.length; i++) {
      let A = []
      const key = keys[i]
      const [keyProvider, region, keyProduct] = keys[i].split('_')
      const startDate3 = moment(selectedPeriod[0])
      for (; startDate3.isSameOrBefore(endDate); startDate3.add(1, 'day')) {
        let value = 0;
        let exist = dataPrices.data[key].filter(e => { return e.date == startDate3.format('YYYY-MM-DD') })
        A.push(exist.length > 0 ? exist[0].price : value)
      }

      let existProvider = dataPrices.providers.filter(e => { return e.id == keyProvider })
      let existProduct = products.filter(e => { return e.value == keyProduct })
      SERIES.push({ name: existProvider[0].skey + ' ' + existProduct[0].label + ' ' + region, data: A })
    }

    for (var i = 0; i < keys2.length; i++) {
      let A = []
      const key = keys2[i]
      const [keyProvider, region, keyProduct] = keys2[i].split('_')
      const startDate3 = moment(selectedPeriod[0])
      for (; startDate3.isSameOrBefore(endDate); startDate3.add(1, 'day')) {
        let value = 0;
        let exist = dataPrices.others[key].filter(e => { return e.price_date == startDate3.format('YYYY-MM-DD') })
        A.push(exist.length > 0 ? exist[0].price : value)
      }

      SERIES.push({ name: dataPrices.others[key][0].enterprise + ' ' + dataPrices.others[key][0].destino + ' ' + dataPrices.others[key][0].product, data: A })
    }

    console.log(SERIES, OPTIONS)
    setSeries(SERIES)
    setOptions(OPTIONS)
  }

  const getDataServer = async function () {
    console.log("selectedProduct", selectedProduct)
    const config = {
      params: {
        promedio_producto: validation.values.promedio_producto,
        promedio_destino: validation.values.promedio_destino,
        providers: selectedProviders.map(e => { return e.value }).join(','),
        product: selectedProduct.map(e => { return e.value }).join(','),
        period: moment(selectedPeriod[0]).format().substring(0, 10) + '/' + moment(selectedPeriod[1]).format().substring(0, 10),
      },
    }
    setLoading(true)
    const dataPrices = await getDistribuitorPriceTable(config)
    setLoading(false)
    console.log("dataPrices", dataPrices)

    const startDate2 = moment(selectedPeriod[0])
    const endDate = moment(selectedPeriod[1])

    let OPTIONS = []
    for (; startDate2.isSameOrBefore(endDate); startDate2.add(1, 'day')) {
      OPTIONS.push(startDate2.format('DD-MM'))
    }
    setFechas(OPTIONS)
    setOptions(OPTIONS)

    setLevel1(dataPrices, OPTIONS)
    setLevel2(dataPrices, OPTIONS)
  }

  useEffect(() => {
    if (selectedPeriod.length == 2 && providers.length > 0 && products.length > 0) {
      getDataServer()
    }
  }, [selectedPeriod, selectedProduct, providers, products, selectedProviders])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cresta</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumb title="Pedidos" breadcrumbItem="Análisis de precios" />
          <Card className="mini-stats-wid">
            <CardBody>
              <Row>
                <Col lg={12} className="text-center">
                  {loading && (
                    <Spinner
                      animation="border"
                      variant="danger"
                      style={{ color: "#f46a6a" }}
                    />
                  )}
                </Col>
                <Col lg={12}>
                  <Row>
                    <Col md={3}>
                      <FormGroup className="mb-4">
                        <Label>Periodo</Label>
                        <InputGroup>
                          <Flatpickr
                            className="form-control d-block"
                            placeholder=""
                            onChange={date => { console.log('period', date); setSelectedPeriod([...date]) }}
                            value={selectedPeriod}
                            options={{
                              mode: "range",
                              dateFormat: "Y-m-d",
                              locale: Spanish,
                              defaultDate: initialPeriod.split("/"),
                            }}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="">Proveedores</Label>
                        <Select
                          isMulti={true}
                          value={selectedProviders}
                          onChange={event => { console.log(event); setSelectedProviders(event) }}
                          options={providers}
                          placeholder="Seleccionar o vacio para todos"
                          classNamePrefix="select2-selection"
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="mb-3">
                        <Label htmlFor="">Productos</Label>
                        <Select
                          isMulti={true}
                          value={selectedProduct}
                          onChange={event => { console.log(event); setSelectedProduct(event) }}
                          options={products}
                          placeholder="Seleccionar"
                          classNamePrefix="select2-selection"
                        />
                      </div>
                    </Col>

                    {false &&
                      <Col md={2}>
                        <div className="mb-3">
                          <NibbleBaseInput
                            md={12}
                            label="Filtrar por producto"
                            fieldName="promedio_producto"
                            fieldType="checkbox-single"
                            validation={validation}
                          />
                        </div>
                      </Col>
                    }
                    {false &&
                      <Col md={2}>
                        <div className="mb-3">
                          <NibbleBaseInput
                            md={12}
                            label="Filtrar por destino"
                            fieldName="promedio_destino"
                            fieldType="checkbox-single"
                            validation={validation}
                          />
                        </div>
                      </Col>
                    }

                    {false && (
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="">Destino</Label>
                          <Select
                            isMulti={true}
                            value={selectedProduct}
                            onChange={event => { console.log(event); setSelectedProduct(event) }}
                            options={products}
                            placeholder="Seleccionar"
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                </Col>
                <Row>
                  <Col md={12} className="pb-3">
                    <Nav tabs className="nav-tabs-custom nav-justified">
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: "proveedor" === activeTab,
                          })}
                          onClick={() => setActiveTab("proveedor")}
                        >
                          <span className="d-block d-sm-none">
                            <i className="fas fa-home"></i>
                          </span>
                          <span className="d-none d-sm-block">Proveedor</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: "proveedor-producto" === activeTab,
                          })}
                          onClick={() => setActiveTab("proveedor-producto")}
                        >
                          <span className="d-block d-sm-none">
                            <i className="fas fa-home"></i>
                          </span>
                          <span className="d-none d-sm-block">Proveedor-Producto</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </Col>
                </Row>
                <Col lg={12}>
                  {"proveedor" === activeTab &&
                    <ComparePricesGraph series={series} options={options} />
                  }
                  {"proveedor-producto" === activeTab &&
                    <ComparePricesGraph series={series2} options={options2} />
                  }
                </Col>
                <Col md={12}>
                  {"proveedor" === activeTab &&
                    <div className="table-responsive">
                      <Table className="table-nowrap table-sm table-hover">
                        <thead>
                          <tr className="">
                            <th>Proveedor</th>
                            {fechas.map(date => (
                              <th key={date} className="text-center">
                                {moment(date, 'DD-MM').format('ddd')}<br />
                                {date.split('-')[0]}
                              </th>
                            ))}
                            <th className="text-center">Prom.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map(item => (
                            <tr
                              key={item.price_id}
                              id={item.price_id}
                            >
                              <td>{item.provider}</td>
                              {item.prices_days.map((item, idx) => (
                                <td key={idx} className="text-center">${nf.format(item)}</td>
                              ))}
                              <td className="text-center">${nf.format(item.price_shipped)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  }

                  {"proveedor-producto" === activeTab &&
                    <div className="table-responsive">
                      <Table className="table-nowrap table-sm table-hover">
                        <thead>
                          <tr className="">
                            <th>Proveedor</th>
                            <th>Producto</th>
                            {fechas.map(date => (
                              <th key={date} className="text-center">
                                {moment(date, 'DD-MM').format('ddd')}<br />
                                {date.split('-')[0]}
                              </th>
                            ))}
                            <th className="text-center">Prom.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData2.map(item => (
                            <tr
                              key={item.price_id}
                              id={item.price_id}
                            >
                              <td>{item.provider}</td>
                              <td>{item.product}</td>
                              {item.prices_days.map((item, idx) => (
                                <td key={idx} className="text-center">${nf.format(item)}</td>
                              ))}
                              <td className="text-center">${nf.format(item.price_shipped)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  }


                  {level == 3 &&
                    <div className="table-responsive">
                      <Table className="table-nowrap table-sm table-hover">
                        <thead>
                          <tr className="">
                            <th>Proveedor</th>

                            <th className="text">Producto</th>

                            <th className="text">Destino</th>

                            <th className="text">Peso</th>
                            <th className="text">Precio</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map(item => (
                            <tr
                              key={item.price_id}
                              id={item.price_id}
                            >
                              <td>{item.provider}</td>
                              {level >= 2 &&
                                <td>{item.product}</td>
                              }
                              {level >= 3 &&
                                <td>{item.region}</td>
                              }
                              <td className="text">{nf.format(item.weight)}</td>
                              <td>${nf.format(item.price_shipped)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  }
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AnalizePrices
